import SectionItem from './SectionItem';

import './SectionItem.scss';

export default SectionItem;
